import React from 'react';
import styled from 'styled-components';

const Feedback = () => {
  const Feedbackdata = [
    { id: 1, title: '99%', text: 'Positive Feedback' },
    { id: 2, title: '2,300+', text: 'Happy Patients a week' },
    { id: 3, title: '43', text: 'Professional Doctors' },
  ];

  return (
    <FeedbackContainer>
      {Feedbackdata.map(data => (
        <FeedbackItem key={data.id}>
          <Heading>{data.title}</Heading>
          <Paragraph>{data.text}</Paragraph>
        </FeedbackItem>
      ))}
    </FeedbackContainer>
  );
};

export default Feedback;

const FeedbackContainer = styled.div`
  background: #062126;
  max-width: 99.1vw;
  min-height: 35vh;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: auto;
  flex-wrap: wrap;
  
  @media (max-width: 768px) {
    justify-content: center;
  }
`;

const FeedbackItem = styled.div`
  flex: 1; /* Equal width for all items */
  padding: 2%; /* Adjust the padding as needed */
text-align: center;
  @media (max-width: 768px) {
    flex: 1 0 100%; /* Full width on smaller screens */
    margin-bottom: 20px;
  }
`;

const Heading = styled.div`
  font-family: 'Poppins', sans-serif;
  font-size: 64px;
  font-weight: 800;
  line-height: 72px;
  letter-spacing: 0em;
  color: white;
`;

const Paragraph = styled.div`
  color: #12ccf4;
  font-family: 'Poppins', sans-serif;
  font-size: 24px;
  font-weight: 500;
  line-height: 27px;
  margin-left: 10px; 
  margin-top: 25px;
`;
